import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { EventService } from '@shared/services/event.service';
import { finalize, takeWhile } from 'rxjs/operators';
import { AuthService } from '@core/auth/auth.service';
import { ApiService } from '@shared/apis';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SpinnerService } from '@shared/services/spinner.service';
import Utils from '@shared/utils/utils';
import Swal from 'sweetalert2';
import { environment } from '@env/environment';
import { Company } from '@shared/enums/company';
import Roles from '@shared/constants/roles';

@Component({
  selector: 'app-create-card-holding',
  templateUrl: './create-card-holding.component.html',
  styleUrls: ['./create-card-holding.component.scss']
})
export class CreateCardHoldingComponent implements OnInit, OnDestroy {

  @Output() reload = new EventEmitter();

  selectedTickets: any[] = [];
  totalAmount = 0;

  billingInfo: any;

  cardForm: FormGroup;

  isLocal = environment.isLocal;
  isDealer;
  company;
  companies = Company;
  private alive = true;

  constructor(private fb: FormBuilder,
              private eventService: EventService,
              private authService: AuthService,
              private spinnerService: SpinnerService,
              private apiService: ApiService) {
    this.company = this.authService.getCurrentCompany();
    this.isDealer = this.authService.hasType(Roles.dealer);
  }

  get form() {
    return this.cardForm.controls;
  }

  ngOnInit(): void {
    const { username, firstName, lastName, organization } = this.authService.getUser();

    if (this.isDealer) {
      this.apiService.dealer.getDealer(organization)
        .subscribe(res => {
          const { address } = res;
          this.billingInfo = {
            firstName,
            lastName,
            address,
            email: username,
          };
        }, err => {
          Utils.showError(err);
        });
    }

    this.eventService.selectTickets$
      .pipe(takeWhile(() => this.alive))
      .subscribe(tickets => {
        if (!tickets) {
          this.selectedTickets = [];
          return;
        }
        this.selectedTickets = tickets;
        this.totalAmount = this.selectedTickets.reduce((prev, curr) => {
          if (curr.cardHoldInfo) {
            return prev + (curr.cardHoldInfo?.amount || 0);
          }
          return prev;
        }, 0);

      });

    this.setFormControls();
  }

  ngOnDestroy() {
    this.alive = false;
  }

  setFormControls() {
    this.cardForm = this.fb.group({
      'cc-number': ['', [Validators.required, Validators.pattern(/^[0-9]+$/)]],
      'cc-exp-month': ['', Validators.required],
      'cc-exp-year': ['', Validators.required],
      'cc-csc': ['', [Validators.required, Validators.pattern(/^[0-9]+$/)]],
    });

    if (this.isLocal) {
      this.cardForm.controls['cc-number'].setValue('4111111111111111');
      this.cardForm.controls['cc-exp-month'].setValue('12');
      this.cardForm.controls['cc-exp-year'].setValue('25');
      this.cardForm.controls['cc-csc'].setValue('000');
    }
  }

  repairCost(pricing, type) {
    if (!pricing) {
      return 0;
    }

    const parts = pricing?.parts ? Number(pricing?.parts[type]) || 0 : 0;
    const labor = pricing?.labor ? Number(pricing?.labor[type]) || 0 : 0;
    return parts + labor;
  }

  submit() {
    const value = this.cardForm.getRawValue();
    const params = {
      cardInfo: {
        cardNumber: value['cc-number'],
        expMM: value['cc-exp-month'],
        expYY: value['cc-exp-year'],
        ccv: value['cc-csc'],
      },
      billing: {
        ...this.billingInfo
      },
      address: this.billingInfo.address,
      ticketNo: this.selectedTickets.reduce((prev, ticket) => {
        const { ticketNo } = ticket;
        prev.push(ticketNo);
        return prev;
      }, []),
    }

    this.spinnerService.start();
    this.apiService.ticket.creditCardPayment(params)
      .pipe(finalize(() => this.spinnerService.stop()))
      .subscribe(() => {
        // TODO message
        Swal.fire({
          icon: 'info',
          title: 'Payment Requested',
          text: 'Your payment requests are in progress\n' +
            'It might be taken half an minute for each ticket.\n' +
            '\n' +
            'The result will be sent to your email address.\n',
        }).then((result) => {
          this.selectedTickets = [];
          // this.cardForm.reset();
          this.reload.emit(true);
        });
      }, err => {
        Utils.showError(err)
      });
  }
}
